import { useEffect, useRef } from 'react';
import RichText from 'Custom/RichText';
import styles from './index.module.scss';

const TruncatedText = ({ className = '', children, ...props }) => {
  const parentRef = useRef(null);
  const truncatedRef = useRef(null);

  useEffect(() => {
    const wrapper = parentRef.current;
    const truncated = truncatedRef.current;

    if (!wrapper || !truncated) {
      return;
    }

    const computeClamp = () => {
      const lineHeight = parseFloat(getComputedStyle(wrapper).lineHeight);
      const elementHeight = wrapper.getBoundingClientRect().height;

      const lines = Math.floor(elementHeight / lineHeight);
      truncated.style.webkitLineClamp = lines;
      truncated.style.lineClamp = lines;
    };

    const observer = new ResizeObserver(computeClamp);
    observer.observe(wrapper);
    computeClamp();

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div
      className={`${styles.truncatedWrapper} ${className}`}
      ref={parentRef}
      {...props}
    >
      <div ref={truncatedRef} className={styles.truncatedText}>
        {children}
      </div>
    </div>
  );
};

export default TruncatedText;
